import React from 'react';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import TakeoutModeButtons from './TakeoutModeButtons';
import { useTranslation } from 'react-i18next';
import ButtonClose from '../Form/ButtonClose';

const TakeoutModeOptions = () => {

    const { t } = useTranslation();
    const { setShowTakeoutModeOptions, takeoutMode } = useOrderTypeContext();

    return (
        <div className="grid gap-6 p-6 pt-8">
            {takeoutMode && <ButtonClose onClick={() => setShowTakeoutModeOptions(false)} fixedOnTop />}

            <div className="grid gap-3">
                <p className='leading-none text-gray-500'>{t('layout.takeout_options.message')}</p>
                <h3 className='text-2xl font-extrabold leading-none text-shopfood-title px-6'>{t('layout.takeout_options.title')}</h3>
            </div>

            <div className='flex items-center gap-2 justify-between flex-wrap'>
                <TakeoutModeButtons onChange={() => setShowTakeoutModeOptions(false) } className='w-full'  />
            </div>
        </div>
    )
}

export default TakeoutModeOptions;